export const VENUS_DISCORD_URL = 'https://discord.gg/venus-protocol-912811548651708448';
export const VENUS_TWITTER_URL = 'https://twitter.com/VenusProtocol';
export const VENUS_GITHUB_URL = 'https://github.com/VenusProtocol/';
export const VENUS_TELEGRAM_URL = 'https://t.me/venusprotocol';
export const VENUS_DOC_URL = 'https://docs-v4.venus.io';
